module.exports = __webpack_public_path__ + "img/girl.a9bcc814.png";